import { render } from "./BaseRowIcon.vue?vue&type=template&id=4e5b0638"
import script from "./BaseRowIcon.vue?vue&type=script&lang=js"
export * from "./BaseRowIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__